import { POST_BUSINESS_PROFILE } from "../configs/routes.js";
import { buildBusinessProfilePayload } from "../utils/businessProfilePayload.js";
import api from "./api.js";

let inFlightCreateRequest = null;
let profileCreateSucceeded = false;

const postBusinessProfile = (businessData = {}) => {
  if (profileCreateSucceeded) {
    return Promise.resolve({ alreadyCreated: true });
  }

  if (inFlightCreateRequest) {
    return inFlightCreateRequest;
  }

  const payload = buildBusinessProfilePayload(businessData);

  inFlightCreateRequest = api
    .post(POST_BUSINESS_PROFILE, payload)
    .then((response) => {
      profileCreateSucceeded = true;
      return response.data;
    })
    .catch((err) => Promise.reject(err.message))
    .finally(() => {
      inFlightCreateRequest = null;
    });

  return inFlightCreateRequest;
};

export default postBusinessProfile;
